import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface UserManagerState {
  netsuiteCustomer: {
    data: any | null
    error: string | null
    isLoading: boolean
  }
  productUser: any | null
  progressReport: {
    data: string | null
    error: string | null
    isLoading: boolean
  }
  archetypes: {
    data: any[] | null
    error: string | null
    isLoading: boolean
  }
  setupAdminUserId: number | null
  isLoading: boolean
  isSaving: boolean
  error: string | null
}

export const initialState: UserManagerState = {
  netsuiteCustomer: {
    data: null,
    error: null,
    isLoading: false,
  },
  productUser: null,
  progressReport: {
    data: null,
    error: null,
    isLoading: false,
  },
  archetypes: {
    data: null,
    error: null,
    isLoading: false,
  },
  setupAdminUserId: null,
  isLoading: false,
  isSaving: false,
  error: null,
}

const slice = createSlice({
  name: 'userManager',
  initialState,
  reducers: {
    clearUsers(state) {
      state.error = null
      state.productUser = null
      state.setupAdminUserId = null
      state.isLoading = false
      state.isSaving = false
    },
    fetchingProductUser(state) {
      state.isLoading = true
    },
    fetchingProductUserSuccess(state, action: PayloadAction<any>) {
      state.isLoading = false
      state.productUser = action.payload
    },
    fetchingProductUserError(state, action: PayloadAction<string>) {
      state.isLoading = false
      state.error = action.payload
    },
    fetchingSetupAdminUserId(state) {
      state.isLoading = true
    },
    fetchingSetupAdminUserIdSuccess(state, action: PayloadAction<number>) {
      state.isLoading = false
      state.setupAdminUserId = action.payload
    },
    fetchingSetupAdminUserIdError(state, action: PayloadAction<string>) {
      state.isLoading = false
      state.error = action.payload
    },
    savingProductUser(state) {
      state.isSaving = true
      state.error = null
      state.productUser = null
    },
    savingProductUserSuccess(state, action: PayloadAction<any>) {
      state.isSaving = false
      state.productUser = action.payload
      state.error = null
    },
    savingProductUserError(state, action: PayloadAction<string>) {
      state.isSaving = false
      state.error = action.payload
      state.productUser = null
    },
    savingProductUserPakSuccess(state) {
      state.isSaving = false
    },
    fetchingNetsuiteCustomer(state) {
      state.netsuiteCustomer = {
        data: null,
        error: null,
        isLoading: true,
      }
    },
    fetchingNetsuiteCustomerSuccess(state, action: PayloadAction<any>) {
      state.netsuiteCustomer = {
        data: action.payload,
        error: null,
        isLoading: false,
      }
    },
    fetchingNetsuiteCustomerError(state, action: PayloadAction<string>) {
      state.netsuiteCustomer = {
        data: null,
        error: action.payload,
        isLoading: false,
      }
    },
    fetchingLessonProgressReport(state) {
      state.progressReport = {
        data: null,
        error: null,
        isLoading: true,
      }
    },
    fetchingLessonProgressReportSuccess(
      state,
      action: PayloadAction<string | null>,
    ) {
      state.progressReport = {
        data: action.payload,
        error: null,
        isLoading: false,
      }
    },
    fetchingLessonProgressReportError(state, action: PayloadAction<string>) {
      state.progressReport = {
        data: null,
        error: action.payload,
        isLoading: false,
      }
    },
    fetchingArchetypes(state) {
      state.archetypes = {
        data: null,
        error: null,
        isLoading: true,
      }
    },
    fetchingArchetypesSuccess(state, action: PayloadAction<any[]>) {
      state.archetypes = {
        data: action.payload,
        error: null,
        isLoading: false,
      }
    },
    fetchingArchetypesError(state, action: PayloadAction<string>) {
      state.archetypes = {
        data: null,
        error: action.payload,
        isLoading: false,
      }
    },
  },
})

export const actions = slice.actions
export default slice.reducer
